import React , { useContext, useState  }from 'react';
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import {Modal } from 'antd';
import { LISTING_POSTS_PAGE, LISTING_POSTS_PAGE_AIRBNB, LISTING_POSTS_PAGE_CAR } from 'settings/constant';
import useMoreDataApi from 'library/hooks/useMoreDataApi';
import { NavbarSearchWrapper } from './Header.style';
import { TITRE_LISTE_HOTEL } from 'library/helpers/constUtils';
import { SharedDataContext } from 'context/SharedDataProvider';
import { loadState } from 'library/helpers/localStorage';

export default function NavbarSearch() {
  let navigate = useNavigate();
  const {  searchType } = useContext(SharedDataContext);
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  let villeValue = urlParams.get('ville');
  
  const [city, setCity] = useState(null)

  const customNoOptionsMessage = () => "Aucune option";
  let url = [
    `${process.env.REACT_APP_API_URL}/villes`
    ] ;
  let { data, loading, error, errorMessage } = useMoreDataApi(url);

  const modalError = (title, message) => {
    Modal.error({
      title: title,
      content: message,
      onOk() {
        return;
      }
    });
  };

  if (error){
    modalError(TITRE_LISTE_HOTEL, 'Ooups! Une erreur est survenue');
    return ; 
  }
  if (data && (data.length== 0 || loading)) { 
    return ;
  }

  let ville = {} ; 
  data.map(
    ({
      key,
      value
    }) => {
      switch (key) {
        case url[0]:
          ville = value ; 
          break;
        default:
          break;
      }
    })


  let adaptedOptions = ville.map(option => ({
    value: option.id,
    label: option.nomVille
  }));


  let defaultValue = null ;
  if (villeValue && !city){
    defaultValue = adaptedOptions.find(option => option.value === parseInt(villeValue))
    setCity(defaultValue);
  }


  const handleChange = (e) => {
    let path = "" ; 
    let currentSearchType = searchType;
    if (loadState("search-type")) {
      currentSearchType = loadState("search-type");
    }
    if (e)
    {
      let basePath;
      if (currentSearchType == "LOCATION") {
        basePath = LISTING_POSTS_PAGE_CAR;
      } else if (currentSearchType == "AIRBNB") {
        basePath = LISTING_POSTS_PAGE_AIRBNB;
      } else {
        basePath = LISTING_POSTS_PAGE;
      }
      path = `${basePath}?ville=${e.value}` ;
        setCity({
          label: (e.label),
          value: (e.value),
        });
    }else{
      setCity({
        label: null,
        value: null,
      });
      let basePath;
      if (currentSearchType == "LOCATION") {
        basePath = LISTING_POSTS_PAGE_CAR;
      } else if (currentSearchType == "AIRBNB") {
        basePath = LISTING_POSTS_PAGE_AIRBNB;
      } else {
        basePath = LISTING_POSTS_PAGE;
      }
      path = basePath;
    }
 
    navigate(path);
    
    window.location.reload(false);

  }
  const lieuPlaceHolder = searchType=="LOCATION"?"Ville":"Où ?"

  return (
    <NavbarSearchWrapper className="navbar_search">
    <Select isClearable className = "select-search" options={adaptedOptions} 
                  onChange={handleChange} defaultValue ={city} placeholder={lieuPlaceHolder} 
                  noOptionsMessage={customNoOptionsMessage} />
                  
      
    </NavbarSearchWrapper>
  );
}
